import { ChangeEventHandler, useState } from "react";

type SearchPredicate<T> = (value: T, idx: number, values: T[]) => boolean;

type UseSearchReturn = {
    search: string;
    matches: (value: string) => boolean;
    setSearch: (search: string) => void;
    bySearch: SearchPredicate<string>;
    bySearchingOn: <T>(select: (value: T) => string | object | null | undefined) => SearchPredicate<T>;
    bindSearchProps: () => { value: string; onChange: ChangeEventHandler<HTMLInputElement> };
};

export function useSearch(initialValue?: string): UseSearchReturn {
    const [search, setSearch] = useState(initialValue ?? "");

    return {
        search,
        setSearch,
        matches(value) {
            if (search == "") return true;
            return value.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        },
        bySearch(value, _idx, _values) {
            if (search.toLocaleLowerCase() == "") return true;

            return value.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        },
        bySearchingOn<T>(select: (value: T) => string | object | null | undefined) {
            return function (value: T, _idx, _values: T[]) {
                if (search.trim() == "") return true;
                const selected = select(value);
                if (selected == null || typeof selected == "undefined") return false;

                const sample = (typeof selected == "object" ? JSON.stringify(selected) : selected).toLocaleLowerCase();
                const parts = search.split(" ").map((each) => each.trim());

                return parts.every((part) => {
                    return sample.includes(part.toLocaleLowerCase());
                });
            };
        },
        bindSearchProps() {
            return {
                value: search,
                onChange: (e) => setSearch(e.target.value),
            };
        },
    };
}
